import { render, staticRenderFns } from "./BulkEditMenu.vue?vue&type=template&id=768bf17a&scoped=true"
import script from "./BulkEditMenu.vue?vue&type=script&lang=ts"
export * from "./BulkEditMenu.vue?vue&type=script&lang=ts"
import style0 from "./BulkEditMenu.vue?vue&type=style&index=0&id=768bf17a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768bf17a",
  null
  
)

export default component.exports